import * as api from '../../api'
import * as endpoints from '../../api/endpoints'

const actions = {
  getFitoProductList({ commit }, payload) {
    return api.fetchFull(endpoints.CATALOG_FITO_PRODUCTS, payload, commit, (response) => {
          return response;
        }
    );
  },
}

export default actions;
